<template>
	<tr class="tableTr">
		<td class="dense">
			<div class="statusWo">
				<span class="statusWo_indicator" :style="`background-color: ${item['wo_type'].toLowerCase() === 'extarnal' ? '#19BC38': '#8F90A6'}`"></span>
				{{ item['wo_type'] }}
			</div>
		</td>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_customer']}">{{ item.customer }}</td>
		<td>{{ item.id }}</td>
		<td>{{ item.unit_type }}</td>
		<td>{{ item.unit }}</td>
		<td align="center"><span class="descN">{{ item.priority }}</span></td>
		<td>{{ item.status }}</td>
<!--		<td>
			<field
					margin="0"
					padding="0"
					height="24"
					:switch-value="isCheck"
					@updateSwitch="onCheckbox"
					is-dense
					is-checkbox
					is-off-style
			></field>
		</td>-->
	</tr>
</template>

<script>

export default {
	name: "TableTr",
	props: {
		item: Object,
		checkAll: Boolean,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	watch: {
		checkAll(val) {
			this.isCheck = val;
			this.item.isCheck = val;
		}
	},
	data: () => ({
		isCheck: false
	}),
	methods: {
		onCheckbox({ value }) {
			this.isCheck = value;
			this.item.isCheck = value;
			this.$emit('updateCheckOrder', this.item['order_id']);
		}
	},
	mounted() {
		this.isCheck = this.item.isCheck;
	}
};
</script>

<style lang="scss" scoped>
@import "PlanerWorkOrdersTableTableTr";
</style>

<style lang="scss">
@import "PlanerWorkOrdersTableTableTrAll";
</style>
